$(function () {
  if ($('#contactform').length > 0) {
    $('#contactform').validationEngine({
      promptPosition: 'inline',
      scrollOffset: ($('.header').outerHeight() + 5),
      onValidationComplete: function (form, status) {
        if (status == true) {
          var response = grecaptcha.getResponse();
          if (response.length == 0) {
            window.alert("「私はロボットではありません」をチェックしてください。");
            return false;
          } else {
            return true;
          }
        }
      }
    });
  }

  if ($('#loginform,#loginform-reg,#loginpass').length > 0) {
    $('#loginform,#loginform-reg,#loginpass').validationEngine({
      promptPosition: 'inline',
      scrollOffset: ($('.header').outerHeight() + 5),
    });
  }
})

$(document).ready(function () {
  if ($('#loginpass').length > 0) {
    $('#loginpass .btn_submit').prop('disabled', true);
  }
  if ($('#loginform').length > 0) {
    $('#loginform .btn_submit').prop('disabled', true);
  }
  if ($('#loginform-reg').length > 0) {
    $('#loginform-reg .btn_submit').prop('disabled', true);
  }
  function checkInputs1() {
    let allFilled = true;
    $('#loginpass input').each(function () {
      if ($(this).val() === '') {
        allFilled = false;
        return false;
      }
    });
    $('#loginpass .btn_submit').prop('disabled', !allFilled);
  }
  function checkInputs2() {
    let allFilled = true;
    $('#loginform input').each(function () {
      if ($(this).val() === '') {
        allFilled = false;
        return false;
      }
    });
    $('#loginform .btn_submit').prop('disabled', !allFilled);
  }
  function checkInputs3() {
    let allFilled = true;
    $('#loginform-reg #RegisterForm-LastName,#loginform-reg #RegisterForm-FirstName,#loginform-reg #RegisterForm-email,#loginform-reg #form-validation-field-0,#loginform-reg #RegisterForm-password').each(function () {
      if ($(this).val() === '') {
        allFilled = false;
        return false;
      }
    });
    $('#loginform-reg .btn_submit').prop('disabled', !allFilled);
  }
  $('#loginpass').on('input', function () {
    checkInputs1();
  });
  $('#loginform').on('input', function () {
    checkInputs2();
  });
  $('#loginform-reg').on('input', function () {
    checkInputs3();
  });
  checkInputs1();
  checkInputs2();
  checkInputs3();
});